import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 27"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M13 .25c-7.21 0-13 5.84-13 13 0 7.21 5.79 13 13 13 7.16 0 13-5.79 13-13 0-7.16-5.84-13-13-13m0 24.375c-2.437 0-4.672-.71-6.5-1.98.203-2.54 2.285-4.52 4.875-4.52h3.25c2.54 0 4.621 1.98 4.824 4.52-1.828 1.27-4.062 1.98-6.449 1.98m7.871-3.2c-.71-2.792-3.25-4.925-6.246-4.925h-3.25c-3.047 0-5.586 2.133-6.297 4.926a11.4 11.4 0 0 1-3.453-8.176C1.625 7.004 6.703 1.875 13 1.875c6.246 0 11.375 5.129 11.375 11.375 0 3.2-1.371 6.094-3.504 8.176M13 6.75a4.04 4.04 0 0 0-4.062 4.063c0 2.285 1.777 4.062 4.062 4.062a4.04 4.04 0 0 0 4.063-4.062A4.074 4.074 0 0 0 13 6.75m0 6.5a2.406 2.406 0 0 1-2.437-2.437A2.44 2.44 0 0 1 13 8.375c1.32 0 2.438 1.117 2.438 2.438A2.44 2.44 0 0 1 13 13.25"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }